import { useState } from 'react';
import { Edit } from '@otp/icons';
import { ActionsColumn as ActionsColumnComponent } from '@otp/ui';
import { User, UsersDocument } from 'src/graphql/generated/graphql';
import { AddUserNoteForm } from './add-user-note-form';

export const ActionsColumn = ({ user }: { user: User }) => {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <ActionsColumnComponent
        icons={[
          {
            icon: <Edit />,
            onClick: () => setShowForm(true),
          },
        ]}
      />
      {showForm && (
        <AddUserNoteForm
          user={user}
          note={user?.adminNote || ''}
          refetchQueries={[UsersDocument]}
          onClose={() => setShowForm(false)}
        />
      )}
    </>
  );
};
